import arc from './arc.js';
import area from './area.js';
import group from './group.js';
import image from './image.js';
import line from './line.js';
import path from './path.js';
import rect from './rect.js';
import rule from './rule.js';
import shape from './shape.js';
import symbol from './symbol.js';
import text from './text.js';
import trail from './trail.js';

export default {
  arc:     arc,
  area:    area,
  group:   group,
  image:   image,
  line:    line,
  path:    path,
  rect:    rect,
  rule:    rule,
  shape:   shape,
  symbol:  symbol,
  text:    text,
  trail:   trail
};
